import { render, staticRenderFns } from "./ErrorPageNotFound.vue?vue&type=template&id=b9324866&scoped=true&"
import script from "./ErrorPageNotFound.vue?vue&type=script&lang=js&"
export * from "./ErrorPageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPageNotFound.vue?vue&type=style&index=0&id=b9324866&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9324866",
  null
  
)

export default component.exports